import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

interface DiscountPerItemContextProps {
  children: ReactNode;
}

interface DiscountPerItemContextData {
  discountPerItem: boolean;
  setDiscountPerItem: Dispatch<SetStateAction<boolean>>;
}

export const DiscountPerItemContext = createContext(
  {} as DiscountPerItemContextData
);

DiscountPerItemContext.displayName = 'DiscountPerItemContext';

export function DiscountPerItemProvider({
  children,
}: DiscountPerItemContextProps) {
  const [discountPerItem, setDiscountPerItem] = useState<boolean>(false);
  return (
    <DiscountPerItemContext.Provider
      value={
        { discountPerItem, setDiscountPerItem } as DiscountPerItemContextData
      }
    >
      {children}
    </DiscountPerItemContext.Provider>
  );
}

export const useDiscountPerItem = () => {
  const context = useContext(DiscountPerItemContext);

  if (!context) {
    throw new Error('must be inside a DiscountPerItemProvider');
  }

  return context;
};
